<section
  class="widget-tabs max-[429px]:w-[343px] min-[430px]:w-auto tablet:w-auto ultrawide:w-[1152px] tablet:justify-center flex laptop:justify-between laptop:gap-[34px] ultrawide:gap-[202px]"
  role="region"
  aria-label="Booking tabs and external links"
  id="mach-core-widget-tabs-section"
>
  <div
    class="tabs min-w-[405px] laptop:w-[477px] desktop:w-auto"
    [id]="content.tabBookingOptions.id"
    (click)="onSearchButtonClick($event)"
  ></div>
  <div
    class="external-links hidden laptop:flex justify-end items-center laptop:w-[417px]"
    aria-label="External links"
    id="mach-core-widget-external-links"
  >
    <a
      (click)="
        onExternalClick(content.externalLinks.links.deltaAmexCard);
        onLinkClick($event)
      "
      href="javascript:void(0)"
      [attr.data-acdl-action]="
        'widget:' + (content.externalLinks.text.deltaAmexCard | lowercase)
      "
      [attr.data-acdl-name]="
        content.externalLinks.text.deltaAmexCard | lowercase
      "
      [attr.data-acdl-page-section]="
        'header:' +
        bookingTab +
        ':' +
        (content.externalLinks.text.deltaAmexCard | lowercase)
      "
      class="external-links__delta-amex h-min no-underline text-caption-semibold text-inverse flex items-center mr-auto"
      role="button"
      tabindex="0"
      (keydown.enter)="
        onExternalClick(content.externalLinks.links.deltaAmexCard);
        onLinkClick($event)
      "
      (keydown.space)="
        onExternalClick(content.externalLinks.links.deltaAmexCard);
        onLinkClick($event)
      "
      [attr.aria-label]="
        content.externalLinks.text.deltaAmexCard +
        content.externalLinks.accessibility.altText
      "
      id="mach-core-widget-delta-amex-link"
    >
      <svg
        class="external-links__gold-card mr-[4px]"
        width="22"
        height="14"
        viewBox="0 0 22 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_14004_127966)">
          <rect
            x="0.6875"
            y="0.4375"
            width="20.625"
            height="13.0143"
            rx="0.9375"
            fill="url(#paint0_linear_14004_127966)"
            stroke="#BAA34A"
            stroke-width="0.375"
          />
          <mask
            id="mask0_14004_127966"
            style="mask-type: alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="22"
            height="14"
          >
            <rect
              x="0.5"
              y="0.25"
              width="21"
              height="13.3893"
              rx="1.125"
              fill="url(#paint1_linear_14004_127966)"
            />
          </mask>
          <g mask="url(#mask0_14004_127966)">
            <g filter="url(#filter0_f_14004_127966)">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M1.27508 4.98697C0.179936 4.98736 -0.545872 6.12594 -0.0852037 7.12085L4.81472 17.7033C5.34752 18.854 6.97713 18.8637 7.5254 17.7195L12.5979 7.13354C13.0755 6.13678 12.3509 4.98304 11.2475 4.98343L1.27508 4.98697Z"
                fill="url(#paint2_linear_14004_127966)"
              />
            </g>
            <path
              d="M4.86915 20.4963L-0.76368 11.8045L2.91225 9.41234L4.86915 20.4963ZM5.93693 18.8938L4.59891 8.3159L13.1319 2.76303L5.93693 18.8938Z"
              fill="url(#paint3_linear_14004_127966)"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M13.1271 2.76009L-4.50565 2.78437L4.59363 8.31328L13.1271 2.76009Z"
              fill="#E1D08B"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M-6.40026 3.11097L-0.76714 11.8031L2.90899 9.41083L-6.40026 3.11097Z"
              fill="#E1D08B"
            />
          </g>
          <rect
            x="3.38252"
            y="4.09419"
            width="2.82614"
            height="1.87525"
            rx="0.58125"
            fill="url(#paint4_linear_14004_127966)"
            stroke="#111111"
            stroke-width="0.0375"
          />
        </g>
        <defs>
          <filter
            id="filter0_f_14004_127966"
            x="-3.22607"
            y="1.9834"
            width="18.9736"
            height="19.5886"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="1.5"
              result="effect1_foregroundBlur_14004_127966"
            />
          </filter>
          <linearGradient
            id="paint0_linear_14004_127966"
            x1="4.9396"
            y1="-0.666108"
            x2="18.1823"
            y2="12.6598"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#BFA958" />
            <stop offset="0.309548" stop-color="#D4BF68" />
            <stop offset="1" stop-color="#BFAA52" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_14004_127966"
            x1="7.18182"
            y1="0.25"
            x2="18.181"
            y2="11.7055"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#A7B0B3" />
            <stop offset="1" stop-color="#858F92" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_14004_127966"
            x1="13.1033"
            y1="5.50875"
            x2="-0.550367"
            y2="7.07661"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#93803D" stop-opacity="0.64" />
            <stop offset="0.276659" stop-color="#93803D" />
            <stop offset="0.73642" stop-color="#93803D" />
            <stop offset="1" stop-color="#93803D" stop-opacity="0" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_14004_127966"
            x1="6.27796"
            y1="7.08858"
            x2="10.4875"
            y2="12.8651"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#A89042" />
            <stop offset="1" stop-color="#CBB55D" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_14004_127966"
            x1="3.84104"
            y1="4.55363"
            x2="5.75159"
            y2="5.50708"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#C7A650" />
            <stop offset="0.500987" stop-color="#DDB758" />
            <stop offset="1" stop-color="#D2AF54" />
          </linearGradient>
          <clipPath id="clip0_14004_127966">
            <rect
              width="21"
              height="13.3893"
              fill="white"
              transform="translate(0.5 0.25)"
            />
          </clipPath>
        </defs>
      </svg>

      <span
        class="external-links__text text-inverse mr-[4px] whitespace-nowrap"
      >
        {{ content.externalLinks.text.deltaAmexCard }}
      </span>
      <svg
        class="external-links__arrow"
        width="8"
        height="8"
        viewBox="0 0 8 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_14004_127980)">
          <mask
            id="path-1-outside-1_14004_127980"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="8"
            height="8"
            fill="black"
          >
            <rect fill="white" width="8" height="8" />
            <path
              d="M7 1V5.40039H6.2002V2.32715L1.56543 7.00098L1 6.43066L5.5918 1.7998H2.59961V1H7Z"
            />
          </mask>
          <path
            d="M7 1V5.40039H6.2002V2.32715L1.56543 7.00098L1 6.43066L5.5918 1.7998H2.59961V1H7Z"
            fill="white"
          />
          <path
            d="M7 1H7.1V0.9H7V1ZM7 5.40039V5.50039H7.1V5.40039H7ZM6.2002 5.40039H6.1002V5.50039H6.2002V5.40039ZM6.2002 2.32715H6.3002V2.08429L6.12919 2.25674L6.2002 2.32715ZM1.56543 7.00098L1.49442 7.07138L1.56542 7.143L1.63644 7.07139L1.56543 7.00098ZM1 6.43066L0.92899 6.36025L0.859178 6.43066L0.928986 6.50107L1 6.43066ZM5.5918 1.7998L5.66281 1.87022L5.83178 1.6998H5.5918V1.7998ZM2.59961 1.7998H2.49961V1.8998H2.59961V1.7998ZM2.59961 1V0.9H2.49961V1H2.59961ZM7 1H6.9V5.40039H7H7.1V1H7ZM7 5.40039V5.30039H6.2002V5.40039V5.50039H7V5.40039ZM6.2002 5.40039H6.3002V2.32715H6.2002H6.1002V5.40039H6.2002ZM6.2002 2.32715L6.12919 2.25674L1.49442 6.93056L1.56543 7.00098L1.63644 7.07139L6.2712 2.39756L6.2002 2.32715ZM1.56543 7.00098L1.63644 6.93057L1.07101 6.36026L1 6.43066L0.928986 6.50107L1.49442 7.07138L1.56543 7.00098ZM1 6.43066L1.07101 6.50107L5.66281 1.87022L5.5918 1.7998L5.52079 1.72939L0.92899 6.36025L1 6.43066ZM5.5918 1.7998V1.6998H2.59961V1.7998V1.8998H5.5918V1.7998ZM2.59961 1.7998H2.69961V1H2.59961H2.49961V1.7998H2.59961ZM2.59961 1V1.1H7V1V0.9H2.59961V1Z"
            fill="white"
            mask="url(#path-1-outside-1_14004_127980)"
          />
        </g>
        <defs>
          <clipPath id="clip0_14004_127980">
            <rect width="8" height="8" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </a>
    <a
      (click)="onLinkClick($event)"
      [href]="content.externalLinks.links.giftCard"
      [attr.data-acdl-action]="
        'widget:' + (content.externalLinks.text.giftCards | lowercase)
      "
      [attr.data-acdl-name]="content.externalLinks.text.giftCards | lowercase"
      [attr.data-acdl-page-section]="
        'header:' +
        bookingTab +
        ':' +
        (content.externalLinks.text.giftCards | lowercase)
      "
      class="external-links__delta-gift-card text-caption-semibold text-inverse no-underline flex items-center"
      role="button"
      tabindex="0"
      (keydown.enter)="onLinkClick($event)"
      (keydown.space)="onLinkClick($event)"
      [attr.aria-label]="
        content.externalLinks.text.giftCards +
        content.externalLinks.accessibility.altText
      "
      id="mach-core-widget-gift-card-link"
    >
      <svg
        class="external-links__gift-card mr-[4px]"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <path
          d="M1.2002 5.09985H22.7998C23.2969 5.09985 23.7002 5.50319 23.7002 6.00024V18.0002C23.7001 18.4972 23.2968 18.8997 22.7998 18.8997H1.2002C0.703204 18.8997 0.29991 18.4972 0.299805 18.0002V6.00024C0.299805 5.50319 0.703139 5.09985 1.2002 5.09985Z"
          fill="white"
          stroke="#80859C"
          stroke-width="0.6"
        />
        <path
          d="M19.5728 9.29507L19.1421 6.23274L20.8041 5.18237L21.3306 5.18611L19.5728 9.29507Z"
          fill="#8B2332"
        />
        <path
          d="M19.2698 9.75393L17.6113 7.22048L18.6593 6.54541L19.2698 9.75393Z"
          fill="#8B2332"
        />
        <path
          d="M17.611 7.24951L16.2739 5.17749L16.6284 5.17998L18.659 6.57437L17.611 7.24951Z"
          fill="#CF0A2C"
        />
        <path
          d="M17.3746 5.18928L20.7892 5.17998L19.1424 6.26301L17.3746 5.18928Z"
          fill="#CF0A2C"
        />
        <path
          d="M1.2002 5.09985H22.7998C23.2969 5.09985 23.7002 5.50319 23.7002 6.00024V18.0002C23.7001 18.4972 23.2968 18.8997 22.7998 18.8997H1.2002C0.703204 18.8997 0.29991 18.4972 0.299805 18.0002V6.00024C0.299805 5.50319 0.703139 5.09985 1.2002 5.09985Z"
          stroke="#AAADBD"
          stroke-width="0.6"
        />
        <rect
          x="3.8877"
          y="11.2009"
          width="14.688"
          height="2.4"
          fill="url(#pattern0_14004_127986)"
        />
        <defs>
          <pattern
            id="pattern0_14004_127986"
            patternContentUnits="objectBoundingBox"
            width="1"
            height="1"
          >
            <use
              xlink:href="#image0_14004_127986"
              transform="scale(0.00259067 0.0166667)"
            />
          </pattern>
          <image
            id="image0_14004_127986"
            width="386"
            height="60"
            preserveAspectRatio="none"
            xlink:href="data:image/png;base64,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"
          />
        </defs>
      </svg>

      <span class="external-links__text text-inverse whitespace-nowrap">
        {{ content.externalLinks.text.giftCards }}
      </span>
    </a>
    <a
      [href]="content.externalLinks.links.updateBagTravelFees"
      (click)="onLinkClick($event)"
      data-acdl-action="widget:updated bags & fees"
      data-acdl-name="updated bags & fees"
      data-acdl-page-section="header:book:updated bags & fees"
      class="external-links__update-bag-travel text-caption-semibold text-inverse no-underline flex items-center ml-auto"
      role="button"
      tabindex="0"
      (keydown.enter)="onLinkClick($event)"
      (keydown.space)="onLinkClick($event)"
      [attr.aria-label]="
        content.externalLinks.text.updateBagTravelFees +
        content.externalLinks.accessibility.altText
      "
      id="mach-core-widget-update-bag-travel-link"
    >
      <span class="external-links__text text-inverse whitespace-nowrap">
        {{ content.externalLinks.text.updateBagTravelFees }}
      </span>
    </a>
  </div>
</section>
